/** 全局时间数据 **/
export const getGlobalConfig = '/client/urbaninsights/globalinfo'

export const getWarehouseData = `/client/urbaninsights/highstandard/summary`
export const getLandData = `/client/urbaninsights/land/summary`
export const getColdData = `/client/urbaninsights/coldstorage/summary`
export const getWarehouseChildData = `/client/urbaninsights/highstandard/areadatasummary`
export const getLandChildData = `/client/urbaninsights/land/regionalmarketdatasummary`
export const getColdChildData = `/client/urbaninsights/coldstorage/areadatasummary`
export const getRentAndVacanciesTime = `/client/urbaninsights/highstandard/estimatedrentvacancyrate`
export const getRentAndVacanciesDeveloper = `/client/urbaninsights/highstandard/developerestimatedrentvacancyrate`
export const dynamicsHighTable = `/client/urbaninsights/highstandard/leasingmarketdynamics`

export const getClientHeadData = `/client/data/getClientHeadData`
export const GetDataList = `/api/data/map/GetDataList`
export const GetProjectList = `/api/data/GetProjectList`
export const GetProjectLists = `/api/data/GetProjectLists`
export const GetProjectInsightList = `/api/data/GetProjectInsightList`
export const GetProjectPageList = `/api/data/GetProjectPageList`



export const Landtotal = `/api/data/landtotal`
export const GetDataTopNumber = `/api/data/GetDataTopNumber`
export const getLandTrends = `/client/urbaninsights/land/landsupplytrends`
export const getColdTrends = `/client/urbaninsights/coldstorage/estimatedrentvacancyrate`
export const dynamicsTransactionTable = `/client/urbaninsights/land/landtransactionactivity`
export const dynamicsColdTable = `/client/urbaninsights/coldstorage/leasingmarketdynamics`

/** 市场报告 **/
export const getPublicReport = `/client/data/getReportsCommon`
export const getVIPReport = `/client/data/getReportsVIP`
export const getCustomReport = `/client/data/getReportsCustomized`
export const getReport = `/client/data/getReports`
export const getAddressTree = `/client/data/getClientHeadData`
/** 首页 **/
export const getHomeData = `/client/home/land/summary`
export const getHomePriceTrend = `/client/home/land/getlandpricecity`
export const getHomeCityTrend = `/client/home/land/getlandsupplytrendscity`
export const getHomeMarketTrend = `/client/home/getleasingmarketdynamicscitytop`
export const getHomeDynamics = `/client/home/leasingmarketdynamics`
export const getCityListByCityName = `/client/data/getCityListByCityName`
export const getCityListPingYin = `/client/data/getCityListPingYin `
export const searchProjectList = `/api/data/searchProjectList`

/** 城市群 **/
export const getCityGroupList = `/client/data/getCityGroupList`
export const getCityGroupDimension = `/data/platform/citygroup/GetCityGroupDimension`
export const getCityGroupDimensionTip = `/data/platform/citygroup/getCityGroupSummary`
export const getStockAndIncrement = `/data/platform/citygroup/GetAreatotalAndNextThreeYearsIncrement`
export const getTotalVolume = `/data/platform/citygroup/GetHighStandardWarehouseSummary`
export const getCityRate = `/data/platform/citygroup/GetHighStandardWarehouseCityGroupRate`
export const getIndustryRate = `/data/platform/citygroup/GetCityGroupCategoryTotal`
export const getEffectiveRent = `/data/platform/citygroup/getCityGroupEffectiveRentVacancyrateTrendChart`
export const getProjectOverview = `/api/data/GetProjectSummary`
export const getProjectDetail = `/api/data/GetProjectDetail`
export const getProjectDetails = `/api/data/GetProjectDetails`
export const getDeveloper = `/api/data/searchProjectDeveloperList`
export const GetProjectByRptNumber = `/api/data/getProjectByRptNumber`


// 首页
export const getQuarterRate=`/client/home/getQuarterVacancyRateCitytop`
export const getQuarterPriceRate=`/client/home/getQuarterEffectiveRentCitytop`

// 导出
export const getProjectStockColumn =`/projectdata/getHighStandardWarehouseAreaTotalColumns`
export const getProjectIncrementColumn =`/projectdata/getHighStandardWarehousePreAddColumns`
export const getProjectColdColumn =`/projectdata/getColdStorageProjectDataColumns`// 导出
export const getProjectStockList =`/projectdata/gethighstandardwarehouseareatotallist`
export const getProjectIncrementList =`/projectdata/gethighstandardwarehousepreaddlist`
export const getProjectColdList =`/projectdata/getcoldstorageprojectdatalist`
export const exportProjectStock =`/projectdata/exporthighstandardwarehouseareatotallistfile`
export const exportProjectIncrement =`/projectdata/exporthighstandardwarehousepreaddlistfile`
export const exportProjectCold =`/projectdata/exportcoldstorageprojectdatalistfile`
export const exportProjectStockTime =`/projectdata/exporthighstandardwarehouseareatotallist`
export const exportProjectIncrementTime =`/projectdata/exporthighstandardwarehousepreaddlist`
export const exportProjectColdTime =`/projectdata/exportcoldstorageprojectdatalist`

export const getCityHighColumn =`/citydata/getHighStandardWarehouseCityDataColumns`
export const getCityColdColumn =`/citydata/getColdStorageCityDataColumns`// 导出
export const getCityHighList =`/citydata/gethighstandardwarehousecitydatalist`
export const getCityColdList =`/citydata/getcoldstoragecitydatacitydatalist`
export const exportCityHigh =`/citydata/exporthighstandardwarehousecitydatalistfile`
export const exportCityCold =`/citydata/exportcoldstoragecitydatalistfile`
export const exportCityHighTime =`/citydata/exporthighstandardwarehousecitydatalist`
export const exportCityColdTime =`/citydata/exportcoldstoragecitydatalist`
export const hasPermissionOfDownload = `/citydata/hasPermissionOfDownload`
//地图
export const GetAuthCities = `/api/data/map/GetAuthCities`
export const GetCountryProject = `/api/data/map/GetCountryProject`
export const GetDataTotal = `/api/data/map/GetDataTotal`
export const GetDataCityTotal = `/api/data/map/GetDataCityTotal`

//首页 --
export const GetUserCityList = `/client/cityAreaData/userCityList`
export const GetCityAreaList = `/client/cityAreaData/cityArea`;
export const GatherCityAreaData = `/client/cityAreaData/gather`;
export const GetCityAreaProjectList = `/client/cityAreaData/projectList`;
export const GetCityAreaProjectPageList = `/client/cityAreaData/projectPageList`;
export const GetCityAreaTenant = `/client/cityAreaData/tenantIndustry`
// 预估有效资金及空置率趋势
export const GetCityEstimatedRentVacancy = `/client/cityAreaData/estimatedRentVacancyRate`
export const GetCityAreaMarketDynamics = `/client/cityAreaData/leasingMarketDynamics`
export const GetCityMassAnalysis = `/client/cityAreaData/massAnalysis`
export const GetCityAreaRentVacancyRate = `/client/cityAreaData/estimatedRentVacancyRate`;
export const GetDeveloperRentVacancyRate = `/client/cityAreaData/developerEstimatedRentVacancyRate`
// 预计增量
export const GetHighStandardExpectNewData = `/client/urbaninsights/highstandard/expectNewData`
// 品牌开发商列表
export const GetHighStandardDeveloperInfo = `/client/urbaninsights/highstandard/developerInfo`
export const GetDeveloperNameList = `/client/urbaninsights/highstandard/developerNameList`
export const GetCurrentInventory = `/client/cityAreaData/currentInventory`
export const GetCityAreaExpectNew = `/client/cityAreaData/expectNewData`

export const cancelCollect = `/report/collect/cancel`
export const addReportCollects = `/report/collect/collegeRpt`
export const getreportCollectLists = `/report/collect/list`
export const getReportLists = `/report/collect/getReportList`
export const cancelReports = `/report/collect/cancelReport`
export const collegeReport = `/report/collect/collegeReport`
export const cancelCollectByRptAndQuarter = `/report/collect/cancelCollectByRptAndQuarter `

export const getTag = `/facorites/tag/list`
export const addTag = `/facorites/tag/add`
export const rptAddToTag = `/facorites/tag/update`
export const deleteTag = `/facorites/tag/delete`